import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

class GdprApp extends Component {
  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  render() {
    return (
      <div className="gdpr_verification">
        <h1>{this.t('GDPR.VerificationTitle')}</h1>
        <a href="https://mtxc.eu" className="button button-dark-blue">{this.t('GDPR.BackLink')}</a>
      </div>
    )
  }
}

export default injectIntl(GdprApp)



// WEBPACK FOOTER //
// ./app/javascript/components/application/gdpr/app.js